"use strict";var e=require("../../../use-sidecar/dist/es2015/medium.js").createSidecarMedium();exports.effectCar=e;
//# sourceMappingURL=medium.js.map
